import { MultiSelectDesignTokens } from '@primeuix/themes/aura/multiselect';

export const multiSelectTokens: MultiSelectDesignTokens = {
  root: {
    background: '{form.field.background}',
    disabledBackground: '{form.field.disabled.background}',
    disabledColor: '{form.field.disabled.color}',
    filledBackground: '{form.field.filled.background}',
    filledFocusBackground: '{form.field.filled.focus.background}',
    filledHoverBackground: '{form.field.filled.hover.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{form.field.border.radius}',
    hoverBorderColor: '{form.field.hover.border.color}',
    focusBorderColor: '{form.field.focus.border.color}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    invalidPlaceholderColor: '{form.field.invalid.placeholder.color}',
    color: '{form.field.color}',
    placeholderColor: '{form.field.placeholder.color}',
    shadow: '{form.field.shadow}',
    paddingX: '{form.field.padding.x}',
    paddingY: '{form.field.padding.y}',
    transitionDuration: '{form.field.transition.duration}',
    focusRing: {
      width: '{form.field.focus.ring.width}',
      style: '{form.field.focus.ring.style}',
      color: '{form.field.focus.ring.color}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    sm: {
      fontSize: '{form.field.sm.font.size}',
      paddingX: '{form.field.sm.padding.x}',
      paddingY: '{form.field.sm.padding.y}',
    },
    lg: {
      fontSize: '{form.field.lg.font.size}',
      paddingX: '{form.field.lg.padding.x}',
      paddingY: '{form.field.lg.padding.y}',
    },
  },
  dropdown: {
    width: '2.5rem',
    color: '{form.field.icon.color}',
  },
  overlay: {
    background: '{overlay.select.background}',
    borderColor: '{overlay.select.border.color}',
    borderRadius: '{overlay.select.border.radius}',
    color: '{overlay.select.color}',
    shadow: '{overlay.select.shadow}',
  },
  list: {
    padding: '{list.padding}',
    gap: '{list.gap}',
    header: {
      padding: '{list.header.padding}',
    },
  },
  option: {
    focusBackground: '{list.option.focus.background}',
    focusColor: '{list.option.focus.color}',
    selectedBackground: 'transparent',
    selectedFocusBackground: '{list.option.focus.background}',
    selectedFocusColor: '{list.option.color}',
    selectedColor: '{list.option.color}',
    color: '{list.option.color}',
    padding: '{list.option.padding}',
    borderRadius: '{list.option.border.radius}',
    gap: '0.5rem',
  },
  optionGroup: {
    background: '{list.option.group.background}',
    color: '{list.option.group.color}',
    fontWeight: '{list.option.group.font.weight}',
    padding: '{list.option.group.padding}',
  },
  chip: {
    borderRadius: '{border.radius.sm}',
  },
  clearIcon: {
    color: '{form.field.icon.color}',
  },
  emptyMessage: {
    padding: '{list.option.padding}',
  },
};
